import React from 'react';
import {get} from 'lodash';

import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import {getDateUtilDefaultInstance} from '/util/date.util';
interface ClientSupportBonusPlusLastEarnedProps {
  item: {
    earnedCsbPlusOn: string | null;
  };
}

export const ClientSupportBonusPlusLastEarned: React.FC<
  ClientSupportBonusPlusLastEarnedProps
> = ({item = {}}) => {
  const lastMonthEarned = get(item, 'earnedCsbPlusOn', null);

  const {tt} = useTranslation('report.record.clientSupportBonusPlusLastEarned');

  return (
    <>
      {tt('clientSupportBonusPlusLastEarned', () => (
        <Text
          variant="body"
          emphasis="medium"
          testID={Reports.reportLastEarned}>
          Last earned{' '}
          {getDateUtilDefaultInstance().formatDate(
            lastMonthEarned,
            'MMMM d, yyyy',
          )}
        </Text>
      ))}
    </>
  );
};
